import React from "react";
import { connect } from "react-redux";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";
import { actions, poppinFormActions, readingActions, signinActions } from "../../../actions";
import * as socialControlsActions from "../../../actions/socialControlsActions";
import { Episode as EpisodeView } from "../../design/Episode";
import EpisodePage from "../../design/Episode/EpisodePage";
import EpisodeLastPage from "./LastPage";
import Poppin from "./Poppin";
import PoppinForm from "./PoppinForm";
import Spinner from "./Spinner";
import ReadingControls from "./ReadingControls";
import { withPaidCheck } from "../paidContentCheck";
import EpisodeDisabled from "./EpisodeDisabled";
import { isLogged } from "../helpers";
import { mutedClick } from "../../design/utilities";

export const Episode = ({
  appendSensorPosition,
  closeAllLists,
  currentPage,
  currentPageSet,
  endIndex,
  lastPageSetVisible,
  lastPageShow,
  openSigninModalWithCallback,
  openedPoppinClose,
  openedPoppinId,
  pages,
  pagesCount,
  poppinForm,
  poppinFormClose,
  poppinFormOpen,
  story,
  showAddPinCursor,
  showPoppins,
  zoom
}) => {
  React.useEffect(() => {
    if (pagesCount === 1) {
      setTimeout(lastPageSetVisible, 800);
    }
  }, []);

  React.useEffect(() => {
    if (currentPage >= pagesCount - 1) {
      lastPageSetVisible();
    }
  }, [currentPage, pagesCount]);

  const poppinFormOpenL = (event, pageId) => {
    mutedClick(event);
    const pagePosition = ReactDOM.findDOMNode(event.target).getBoundingClientRect();
    const posX = (event.clientX - pagePosition.left) / pagePosition.width;
    const posY = (event.clientY - pagePosition.top) / pagePosition.height;
    if (isLogged()) {
      poppinFormOpen(pageId, posX, posY);
    } else {
      closeAllLists();
      openSigninModalWithCallback(poppinFormOpen, "poppinFormOpen", [pageId, posX, posY]);
    }
  };

  const episodePageOnClick = (event, pageId) => {
    if (openedPoppinId) {
      openedPoppinClose();
    } else if (showPoppins && poppinForm.pageId !== pageId) {
      poppinFormOpenL(event, pageId);
    } else {
      poppinFormClose();
    }
  };

  return (
    <EpisodeView onClick={closeAllLists} className="px1 lg-px0">
      {pages &&
        pages.slice(0, endIndex).map((page, pageIdx) => (
          <VisibilitySensor
            key={pageIdx}
            onChange={isVisible => isVisible && currentPageSet(pageIdx + 1)}
            partialVisibility={true}
          >
            <div>
              <EpisodePage
                key={pageIdx}
                pageIdx={pageIdx}
                img={page.webreader_image_url}
                pagesCount={pagesCount}
                showAddPinCursor={showAddPinCursor}
                zoom={zoom}
                onClick={event => {
                  episodePageOnClick(event, page.id);
                }}
              >
                {showPoppins &&
                  page.tsukkomi_comments.map((poppin, pinIdx) => (
                    <Poppin key={pinIdx} pinIdx={pinIdx} pageIdx={pageIdx} {...poppin} />
                  ))}

                {showPoppins && <PoppinForm currentPageId={page.id} pageIdx={pageIdx} />}
              </EpisodePage>
              {pageIdx >= appendSensorPosition && (
                <VisibilitySensor onChange={isVisible => isVisible && batchAppend(pagesCount)} />
              )}
            </div>
          </VisibilitySensor>
        ))}

      {lastPageShow ? <EpisodeLastPage /> : <Spinner />}
      <ReadingControls />
    </EpisodeView>
  );
};

const mapState = (state, ownProps) => ({
  currentEpisode: state.currentEpisode,
  story: state.story,
  pages: state.currentEpisode.pages,
  pagesCount: state.currentEpisode.pages && state.currentEpisode.pages.length,
  showAddPinCursor: state.reading.showPoppins && !state.poppinForm.pageId,
  poppinForm: state.poppinForm,
  ...state.reading
});

const mapDispatch = (dispatch, ownProps) => ({
  batchAppend: pagesCount => {
    dispatch(readingActions.batchAppend(pagesCount));
  },
  closeAllLists: () => {
    dispatch(actions.episodesControlsSetClosed());
    dispatch(socialControlsActions.closeDrawer());
    dispatch(socialControlsActions.closeSocialDropdown());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeUserMenu());
  },
  lastPageSetVisible: () => {
    dispatch(readingActions.lastPageSetVisible());
  },
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(signinActions.openModalWithCallback(callback, callbackType, callbackArgs));
  },
  currentPageSet: currentPage => {
    dispatch(readingActions.currentPageSet(currentPage));
  },
  openedPoppinClose: () => {
    dispatch(readingActions.openedPoppinClose());
  },
  poppinFormClose: () => {
    dispatch(poppinFormActions.poppinFormClose());
  },
  poppinFormOpen: (pageId, posX, posY) => {
    dispatch(poppinFormActions.poppinFormOpen(pageId, posX, posY));
  }
});

const EpisodeEnabled = connect(mapState, mapDispatch)(Episode);
const AuthorizedEpisode = withPaidCheck(EpisodeEnabled, EpisodeDisabled);

export default AuthorizedEpisode;
